import { MutationOptions } from '@tanstack/react-query';

import { useApiMutation } from '~/hooks';
import {
  createValidationJobApi,
  downloadValidationTaskApi,
  CreateValidationJobData,
  CreateValidationJobResponse,
} from '../repository';

/**
 * Mutation hook for creating validation jobs
 * @param options - Additional mutation options
 * @returns React Query mutation result
 */
export const useCreateValidationJobMutation = (
  options?: MutationOptions<
    CreateValidationJobResponse,
    CustomAxiosError,
    CreateValidationJobData
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: createValidationJobApi,
  });
};

/**
 * Mutation hook for downloading validation task results
 * @param options - Additional mutation options
 * @returns React Query mutation result
 */
export const useDownloadValidationTaskMutation = (
  options?: MutationOptions<
    void,
    CustomAxiosError,
    {
      taskId: string;
      format: 'csv' | 'excel';
      fileName?: string;
      type?: 'EMAIL' | 'PHONE';
    }
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: async ({ taskId, format, fileName, type }) => {
      const blob = await downloadValidationTaskApi(taskId, format, type);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download =
        fileName ||
        `validation-results-${taskId}.${format === 'csv' ? 'csv' : 'xlsx'}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
  });
};
